/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from 'react-i18next';
import { Affix, Button } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import RopaService from '../../../../services/Ropa.service';
import { ROUTER } from '../../../../constants/router';
import { STATUS_ID as STATUS } from '../../STATUS_ID';

const Tab4 = ({ collectDataDestruction, editMode, storageLocation, isNoPermission, detailInfo }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { activityId } = useParams();
    const [masterPrevent, setMasterPrevent] = useState([]);
    const [masterOwner, setMasterOwner] = useState([]);

    useEffect(() => {
        getMasterPrevent();
        getMasterOwner();
    }, []);

    const getMasterPrevent = async () => {
        try {
            const { data } = await RopaService.getMasterPrevent(activityId);
            if (data?.resultData) {
                setMasterPrevent(data?.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getMasterOwner = async () => {
        try {
            const { data } = await RopaService.getMasterOwner(activityId);
            if (data?.resultData) {
                setMasterOwner(data?.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getMasterStorageLocationName = (id) => {
        if (id && storageLocation?.length > 0) {
            const result = storageLocation.filter((data) => data.id === id);
            if (result?.length > 0) {
                return (
                    <p className="mb-0">
                        &#8226; {result[0].name ? result[0].name : '-'}
                    </p>
                );
            }
        }
    };

    const getMasterPreventControlDataName = (id) => {
        if (id && masterPrevent?.length > 0) {
            const result = masterPrevent.filter((data) => data?.id === id);
            if (result?.length > 0) {
                return <p className="mb-0">&#8226; {result[0].name}</p>;
            }
        }
    };

    const getMasterOwnerAccessName = (id) => {
        if (id && masterOwner?.length > 0) {
            const result = masterOwner.filter((data) => data.id === id);
            if (result?.length > 0) {
                return <p className="mb-0">&#8226; {result[0].name}</p>;
            }
        }
    };

    return (
        <div className="grid grid-cols-3">
            <div className="col-span-3 text-right mt-2 mb-2">
                <Affix offsetTop={60}>
                    <Button
                        hidden={!editMode || (isNoPermission && (detailInfo?.statusId === STATUS.WAITING_FOR_REVIEW || detailInfo?.statusId === STATUS.REVISE))}
                        type="primary"
                        style={{ padding: '0px 30px' }}
                        onClick={() => {
                            navigate(
                                `${ROUTER.DS_INVENTORY.ROPA}/${activityId}?tab=4`
                            );
                        }}
                        size="large"
                        ghost
                    >
                        {t('common.Edit')}
                    </Button>
                </Affix>
            </div>

            {/* <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.retentionData')}
                </div>
                <p className="mb-0">
                    {collectDataDestruction?.retentionData
                        ? collectDataDestruction.retentionData
                        : '-'}
                </p>
            </div> */}

            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.storageLocation')}
                </div>

                {collectDataDestruction?.storageLocation.length > 0 &&
                    collectDataDestruction?.storageLocation.map((item) =>
                        getMasterStorageLocationName(item)
                    )}
                {collectDataDestruction?.storageLocationAddOn.map((item) => (
                    <p className="mb-0">&#8226; {item}</p>
                ))}
            </div>

            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.processRequestingDataApproval')}
                </div>
                <p className="mb-0 whitespace-pre-wrap">
                    {collectDataDestruction?.processRequestingDataApproval &&
                        collectDataDestruction.processRequestingDataApproval}
                </p>
            </div>

            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.preventControlDataDetails')}
                </div>
                {collectDataDestruction?.preventControlDataDetail.length > 0 &&
                    collectDataDestruction?.preventControlDataDetail.map(
                        (item) => getMasterPreventControlDataName(item)
                    )}
            </div>

            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.stepTodeleteDestructionData')}
                </div>
                <p className="mb-0 whitespace-pre-wrap">
                    {collectDataDestruction?.stepToDeleteDestructionData
                        ? collectDataDestruction.stepToDeleteDestructionData
                        : '-'}
                </p>
            </div>

            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.ownerAcessDelete')}
                </div>
                {collectDataDestruction?.ownerAccessDelete.length > 0 &&
                    collectDataDestruction?.ownerAccessDelete.map((item) =>
                        getMasterOwnerAccessName(item)
                    )}
            </div>
        </div>
    );
};
export default Tab4;
